import TelegramIcon from './icons/TelegramIcon';
import FullImageShare from './ui/FullImageShare';
import TelegramFull from '../assets/images/share/telegram_full.png';
export default function TelegramShareButton({ validated, sharePostTitle, onSendEvent, fullIcon, certificate }) {
    return (
        <>
            {validated && (
                <a
                    href={`https://t.me/share/url?url=${certificate.url}&text=${sharePostTitle}`}
                    onClick={() => onSendEvent('telegram')}
                    target="_blank"
                >
                    {fullIcon && <FullImageShare img={TelegramFull} />}
                    {!fullIcon && <TelegramIcon />}
                </a>
            )}
            {!validated && <TelegramIcon fill={'#F6F6F6'} />}
        </>
    );
}
